import * as workOrdersService from '../../../services/WorkOrders/workOrdersService';
import {createDialogActions} from '../../Dialogs/CommonDialog/commonDialogActions';

export const {
  actionTypes,
  actions,
  api,
  jsxActions,
} = createDialogActions({

  config: {
    getSubmitMethod: () => workOrdersService.updateWorkOrderStatus,
  },
});
